import { Address } from 'viem';

export const THQ_ETHEREUM: Address = '0xafFbe9a60F1F45E057FD9b6DC70004Bb0Ccc8b99';

export const ETH_ERC_20: Address = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';
